const ENDPOINT = 'GETmanagepodcasts';
function getManagePodcasts(gateway, params) {
    return gateway.get(getManagePodcasts.endpoint, params);
}
getManagePodcasts.endpoint = ENDPOINT;

export { getManagePodcasts as default };
//# sourceMappingURL=getManagePodcasts.js.map
